/**
 * No Profile Guard
 *
 * Protects the /workspace/no-profile route to ensure only users WITHOUT a profile can access it.
 * If the user has a profile, redirects to /workspace/home.
 *
 * This prevents users with valid profiles from accessing the no-profile page.
 *
 * @example
 * {
 *   path: 'admin/no-profile',
 *   canActivate: [authGuard, noProfileGuard],
 *   component: NoProfilePage
 * }
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountState } from 'src/app/store/account/account.state';

/**
 * No Profile Guard
 *
 * Checks if the user does NOT have a profile for the active team.
 * If they do have a profile, redirects to /workspace/home.
 */
export const noProfileGuard: CanActivateFn = (route, state) => {
  const accountState = inject(AccountState);
  const router = inject(Router);

  // Check if user has a profile for the active team
  const activeProfile = accountState.activeProfile();

  if (activeProfile) {
    // User has profile - redirect to admin home
    console.log('[NoProfileGuard] Profile found - redirecting to /workspace/home');
    router.navigate(['/workspace/home']);
    return false;
  }

  // User has no profile - allow access to no-profile page
  console.log('[NoProfileGuard] No profile - allowing access to no-profile page');
  return true;
};

